document.querySelectorAll('details.quickfilters > summary').forEach(summary => {
      summary.addEventListener('click', function(event) {
          const details = this.parentElement;
          // Prevent the default toggle behavior
          event.preventDefault();
          // Explicitly set the 'open' attribute to ensure it stays open
          details.setAttribute('open', true);
      });
  });

document.addEventListener('DOMContentLoaded', () => {
    const currentUrl = window.location.href;
    if (window.innerWidth >= 767) {
      show_filter_sidebar();
    }
    // else{
    //       // $(".custom-fullwidth-section aside#main-collection-filters , .custom-fullwidth-section .caption , .product-grid-container").addClass("show-filters");
    // // $(".facets-vertical .facets__disclosure").css("display" ,"block");
    // // $(".facets-vertical .facets__disclosure.quickfilters").css("display" ,"none");
    // // $(".filter-toggle").addClass("hide");
    // // $(".filter-toggle-close").removeClass("hide");
    //   show_filter_sidebar();
    // }
    if (window.innerWidth <= 768) {
        // Select the elements you want to observe and update
        const observedElement = document.querySelector('.active-facets.active-facets-desktop.horizontal.custom-filter-indicator');
        const targetElement = document.querySelector('form#FacetFiltersForm');

        // Function to update the margin-top based on the height of the observed element
        const updateMarginTop = () => {
            if (observedElement && targetElement) {
                const newHeight = observedElement.getBoundingClientRect().height;
                // console.log(`Initial height: ${newHeight}px`);
                targetElement.style.marginTop = `${newHeight}px`;
            } else {
                // console.error('Observed or target element not found');
            }
        };

        // Create a callback function to execute when the height changes
        const heightChangeCallback = (entries) => {
            for (let entry of entries) {
                const newHeight = entry.contentRect.height;
                // console.log(`New height: ${newHeight}px`);
                // Update the margin-top of the target element
                if (targetElement) {
                    targetElement.style.marginTop = `${newHeight}px`;
                } else {
                    // console.error('Target element not found');
                }
            }
        };

        // Create a new ResizeObserver instance with the callback function
        const resizeObserver = new ResizeObserver(heightChangeCallback);

        // Start observing the selected element
        if (observedElement) {
            resizeObserver.observe(observedElement);
        } else {
            // console.error('Observed element not found');
        }

        // Perform the initial height check and margin-top update
        updateMarginTop();
    } else {
        // console.log('Screen size is not mobile, script will not run');
    }



const anchors = parentElement.querySelectorAll('a.active-facets__button-remove');

// Attach click event listener to each anchor
anchors.forEach(anchor => {
    anchor.addEventListener('click', function() {
        // console.log('remove btn click');
    });
});

  
});

const quickFilters = document.querySelector('details.quickfilters');
const sortFilters = document.querySelector('.facet-filters.sorting.caption');
const initialTop = 12.5; // Initial top value in percent
const initialTop2 = 14.9; 

function onScroll() {
    if (window.innerWidth <= 768) { // Check if the screen size is for mobile devices
        const scrollPosition = window.scrollY;
        const newTopValue = initialTop - scrollPosition * 0.10; // Adjust this multiplier as needed
        const newTopValue2 = initialTop2 - scrollPosition * 0.10; 
        quickFilters.style.top = newTopValue + '%';
        sortFilters.style.top = newTopValue2 + '%';
      // console.log(newTopValue2);
    }
}

window.addEventListener('scroll', onScroll);

// Optional: Recheck screen size on window resize and adjust if necessary
window.addEventListener('resize', function() {
    if (window.innerWidth <= 768) {
        onScroll();
    } else {
        quickFilters.style.top = initialTop + '%'; 
        sortFilters.style.top = initialTop2 + '%';
    }
});

function carouselifyCollectionNew() {
// console.log("Executing carouselifyCollection new...");

const collection_carousels = document.querySelectorAll('.custom.carouselOfImages');

collection_carousels.forEach(carousel => {
    // Check if the carousel has a Flickity instance
    if ($(carousel).data('flickity')) {
        $(carousel).flickity('destroy'); // Destroy existing Flickity instance
    }

    // Reinitialize Flickity
    new Flickity(carousel, {
        // options go here
        cellAlign: 'left',
        contain: false,
        friction: 0.2,
        initialIndex: 0,
        pageDots: true,
        lazyLoad: false,
        wrapAround: true,
        cellSelector: '.collection-product__anchor',
        prevNextButtons: false,
    });
});
  var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");

  // Delay hiding elements to allow Tolstoy to add content
  setTimeout(function() {
    tolstoyTiles.forEach(function (tile) {
      // Check if the tile still has no child nodes after the delay
      if (!tile.hasChildNodes()) {
        tile.style.display = "none";
      }
    });
  }, 3000)

// console.log("carouselifyCollection executed new");
}





function destroyingCarousel() {
// console.log("Destroying carouselifyCollection...");

// Carousel init
const collection_carousels = document.querySelectorAll('.custom.carouselOfImages');

collection_carousels.forEach(carousel => {
    // Check if the carousel has a Flickity instance
    if ($(carousel).data('flickity')) {
        // Destroy the Flickity instance
        $(carousel).flickity('destroy'); 
    }
});

// console.log("Destroying carouselifyCollection executed");
}





function carouselifyCollection() {
     // console.log("executing carouselifyCollection.... ");
  // Carousel init
  // creates a node list of all carousels on the same page
  const collection_carousels = document.querySelectorAll('.custom.carouselOfImages');

  collection_carousels.forEach(carousel => {
    // let prod_url = carousel.querySelector('.collection-product__anchor').getAttribute('href');
    
    new Flickity(carousel, {
      // options go here
      celAllign: 'left',
      contain:false,
      friction: 0.2,
      initialIndex: 0,
      pageDots: true,
      lazyLoad: false,
      wrapAround: true,
      cellSelector: '.collection-product__anchor',
      prevNextButtons: false,
    });

  });

    var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");

  // Delay hiding elements to allow Tolstoy to add content
  setTimeout(function() {
    tolstoyTiles.forEach(function (tile) {
      // Check if the tile still has no child nodes after the delay
      if (!tile.hasChildNodes()) {
        tile.style.display = "none";
      }
    });
  }, 3000)
  // console.log("carouselifyCollection executed");
}



function carouselifyCollectionLatest() {
// console.log("executing carouselifyCollection latest.... ");

// Carousel init
// Creates a node list of all carousels on the same page
const collection_carousels = document.querySelectorAll('.custom.carouselOfImages');

collection_carousels.forEach(carousel => {
// Check if Flickity is already initialized
if (carousel.classList.contains('flickity-enabled')) {
  // console.log("Flickity instance already exists, skipping reinitialization...");
  return; // Skip reinitialization if Flickity is already enabled
}

// Remove any previous flickity-viewport to ensure clean initialization
const existingViewport = carousel.querySelector('.flickity-viewport');
if (existingViewport) {
  existingViewport.remove(); // Remove the existing Flickity viewport if it exists
}

// Create a new Flickity instance
new Flickity(carousel, {
  cellAlign: 'left',
  contain: false,
  friction: 0.2,
  initialIndex: 0,
  pageDots: true,
  lazyLoad: false,
  wrapAround: true,
  cellSelector: '.collection-product__anchor',
  prevNextButtons: false,
});
});

  var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");

  // Delay hiding elements to allow Tolstoy to add content
  setTimeout(function() {
    tolstoyTiles.forEach(function (tile) {
      // Check if the tile still has no child nodes after the delay
      if (!tile.hasChildNodes()) {
        tile.style.display = "none";
      }
    });
  }, 3000)
  
// console.log("carouselifyCollection executed latest");
}







document.addEventListener('DOMContentLoaded', () => {
//applyStyles();


  // Check if the current URL contains "/collections/"
let currentUrl = window.location.href;

 if (currentUrl.includes("/collections/")) {
// Select the container with class 'products-on-page'
let productsContainer = document.querySelector('.products-on-page');

if (productsContainer) {
    // Retrieve stored content for the specific page from local storage
    const savedContent = localStorage.getItem(currentUrl);

    // If there is saved content for this URL, inject it into the 'products-on-page' container
    if (savedContent) {
        // console.log('Restoring content for', currentUrl);
        productsContainer.innerHTML = savedContent;
        // console.log('Content restored for', currentUrl);

        let pageKey = window.location.pathname;
        //const totalItemsElement = document.querySelector('.total-items');
        const totalDisplayedElement = document.querySelector('.displayed-products');

        // if (localStorage.getItem(pageKey + '-totalItems')) {
        //     let savedTotalItems = localStorage.getItem(pageKey + '-totalItems');
            
        //     // Check if "of" is already present
        //     if (!savedTotalItems.includes("of")) {
        //         let newtext = " of " + savedTotalItems;
        //         totalItemsElement.setAttribute('total-item-value', savedTotalItems);
        //         totalItemsElement.textContent = newtext;
        //     } else {
        //         totalItemsElement.setAttribute('total-item-value', savedTotalItems);
        //         totalItemsElement.textContent = savedTotalItems;
        //     }
        // }

        if (localStorage.getItem(currentUrl + '-totalDisplayed')) {
            let savedTotalDisplayed = localStorage.getItem(currentUrl + '-totalDisplayed');
            totalDisplayedElement.setAttribute('total-displayed', savedTotalDisplayed);
            totalDisplayedElement.textContent = savedTotalDisplayed;
        }
    }
}

// Add an event listener for the `beforeunload` event to save the content when the user exits
window.addEventListener('beforeunload', function () {
   productsContainer = document.querySelector('.products-on-page');
    if (productsContainer) {
        destroyingCarousel();

        // Create a temporary container to manipulate savedContent
        let tempContainer = document.createElement('div');
        tempContainer.innerHTML = productsContainer.innerHTML;

        // Retain contents inside flickity-viewport and remove the viewport div itself
        let flickityViewportElements = tempContainer.querySelectorAll('.flickity-viewport');
        flickityViewportElements.forEach(viewport => {
            let anchors = viewport.querySelectorAll('.collection-product__anchor');
            anchors.forEach(anchor => {
                viewport.parentNode.insertBefore(anchor, viewport); // Move anchor out of viewport
            });
            viewport.remove(); // Remove the flickity-viewport div
        });

        // Remove flickity-slider element while keeping its content
        let flickitySliderElements = tempContainer.querySelectorAll('.flickity-slider');
        flickitySliderElements.forEach(slider => {
            while (slider.firstChild) {
                slider.parentNode.insertBefore(slider.firstChild, slider);
            }
            slider.remove(); // Remove the flickity-slider itself
        });

        // Remove inline styles from all 'collection-product__anchor' elements
        let anchorElements = tempContainer.querySelectorAll('.collection-product__anchor');
        anchorElements.forEach(anchor => {
            anchor.removeAttribute('style');
        });

        // Remove flickity-page-dots element entirely
        let flickityDots = tempContainer.querySelector('.flickity-page-dots');
        if (flickityDots) {
            flickityDots.remove();
        }

        // Now assign the updated content
        let pageKey = window.location.pathname;
        let updatedContent = tempContainer.innerHTML;
        currentUrl = window.location.href;
        localStorage.setItem(currentUrl, updatedContent);
        // console.log('Saving content before page unload. Current URL:', currentUrl);

        let totalItems = document.querySelector('.total-items').getAttribute('total-item-value');
        //localStorage.setItem(pageKey + '-totalItems', totalItems);

        let totalDisplayed = document.querySelector('.displayed-products').getAttribute('total-displayed');
        localStorage.setItem(currentUrl + '-totalDisplayed', totalDisplayed);
    }
});

// Save content when the user navigates to another page or tab (within the same session)
window.addEventListener('pagehide', function () {
   productsContainer = document.querySelector('.products-on-page');
    if (productsContainer) {
        destroyingCarousel();

        let tempContainer = document.createElement('div');
        tempContainer.innerHTML = productsContainer.innerHTML;

        let flickityViewportElements = tempContainer.querySelectorAll('.flickity-viewport');
        flickityViewportElements.forEach(viewport => {
            let anchors = viewport.querySelectorAll('.collection-product__anchor');
            anchors.forEach(anchor => {
                viewport.parentNode.insertBefore(anchor, viewport);
            });
            viewport.remove();
        });

        let flickitySliderElements = tempContainer.querySelectorAll('.flickity-slider');
        flickitySliderElements.forEach(slider => {
            while (slider.firstChild) {
                slider.parentNode.insertBefore(slider.firstChild, slider);
            }
            slider.remove();
        });

        let anchorElements = tempContainer.querySelectorAll('.collection-product__anchor');
        anchorElements.forEach(anchor => {
            anchor.removeAttribute('style');
        });

        let flickityDots = tempContainer.querySelector('.flickity-page-dots');
        if (flickityDots) {
            flickityDots.remove();
        }

        productsContainer.innerHTML = tempContainer.innerHTML;
       
        
        let updatedContent = tempContainer.innerHTML;
        currentUrl = window.location.href;
        localStorage.setItem(currentUrl, updatedContent);
        // console.log('Saving content on pagehide. Current URL:', currentUrl);

        let totalItems = document.querySelector('.total-items').getAttribute('total-item-value');
        //localStorage.setItem(current_url + '-totalItems', totalItems);

        let totalDisplayed = document.querySelector('.displayed-products').getAttribute('total-displayed');
        localStorage.setItem(currentUrl + '-totalDisplayed', totalDisplayed);
    }
});
}



setTimeout(() => {
             // console.log('carouselify executing');
               carouselifyCollectionNew();
             //  console.log('carouselify executed');
             }, 3000);

if (localStorage.getItem(currentUrl + '-fullyloaded') ) {
  let fullyLoaded = localStorage.getItem(currentUrl + '-fullyloaded');
    if(fullyLoaded==true){
          // console.log('fully loaded: ',fullyLoaded);
          document.querySelector('.load-more-btn').style.setProperty('display', 'none', 'important');
    }
        }
});


function addClass(){
  document.querySelectorAll('.carouselContainer').forEach(carouselContainer => {
    carouselContainer.classList.add('custom-carousel-container');
  });
}


function applyStyles() {
// Select all viewport elements within the custom collection template
var viewports = document.querySelectorAll('.custom-collection-template .flickity-viewport');
var sliderImages = document.querySelectorAll('.custom-collection-template .flickity-slider img');

// Get the screen width
var screenWidth = window.innerWidth;

// Set default height
var viewportHeight = '342px';
var imgHeight = '342px';

// Change height if screen width is 1420px or more
if (screenWidth >= 1420) {
    viewportHeight = '490px';
    imgHeight = '490px';
}

// Apply styles to each viewport element
viewports.forEach(function(viewport) {
    viewport.style.height = viewportHeight;
});

// Apply styles to each slider image
sliderImages.forEach(function(img) {
    img.style.height = imgHeight;
    img.style.objectFit = 'cover';
});
}

// Call the function on window resize to ensure styles are applied correctly
//window.addEventListener('resize', applyStyles);

function removeStyles() {
// Select all viewport elements within the custom collection template
var viewports = document.querySelectorAll('.custom-collection-template .flickity-viewport');
var sliderImages = document.querySelectorAll('.custom-collection-template .flickity-slider img');

// Remove styles from each viewport element
viewports.forEach(function(viewport) {
    viewport.style.height = '';
});

// Remove styles from each slider image
sliderImages.forEach(function(img) {
    img.style.height = '';
    img.style.objectFit = '';
});
}

// Get the parent element with the ID "FacetFiltersForm"
let parentElement = document.getElementById("FacetFiltersForm");

// Store the current scroll position
const colScrollX = window.scrollX;
const colScrollY = window.scrollY;
// Add event listener to the parent element
parentElement.addEventListener("click", function(event) {

  
// Check if the clicked element is a checkbox
let products_on_page = document.querySelector('.products-on-page');
    // console.log("Checkbox clicked:", event.target);
    setTimeout(() => {
     carouselifyCollectionNew();
     if (event.target.tagName === 'INPUT' && event.target.type === 'checkbox') {
       next_url = products_on_page.getAttribute('data-next-url');
       //getHiddenProductCount();
       next_url_c = window.location.href;
       getAllProductList();
     }
      
      document.querySelectorAll('.facets__label.facet-checkbox--disabled[facets__label]').forEach(function(item) {
        if(document.querySelector('.custom_collection_filter[filter_val='+ item.getAttribute('facets__label') +']')){
          document.querySelector('.custom_collection_filter[filter_val='+ item.getAttribute('facets__label') +']').classList.add('facet-checkbox--disabled');
        }else if(document.querySelector('.custom_collection_filter[filter_val='+ item.getAttribute('facets__label') +'].facet-checkbox--disabled')){
          document.querySelector('.custom_collection_filter[filter_val='+ item.getAttribute('facets__label') +']').classList.remove('facet-checkbox--disabled');          
        }
      });
      
    }, 3000);

    var filter_label = document.querySelectorAll('.facets__label[facets__label]');
    if(filter_label){
      filter_label.forEach(function(item) {
        if (event.target.tagName === 'INPUT') {
           var filter_label_ = event.target.parentNode.getAttribute('facets__label');
          if (document.querySelector('.custom_collection_filter[filter_val='+ filter_label_ +'].active_filter')) {
            if (document.querySelector('.custom_collection_filter[filter_val='+ filter_label_ +']')) {
              document.querySelector('.custom_collection_filter[filter_val='+ filter_label_ +']').classList.remove('active_filter');
            }
          }
          else{          
            if (document.querySelector('.custom_collection_filter[filter_val='+ filter_label_ +']')) {
              document.querySelector('.custom_collection_filter[filter_val='+ filter_label_ +']').classList.add('active_filter');
            }
          }
        }
      });
    }
    
    setTimeout(function() {
      // window.scrollTo({ top: '1000px', behavior: 'smooth' });
      // smoothScroll(document.querySelector(".filter-toggle-container"));
    },2000);
});




// Function to handle URL changes
function onUrlChange() {
// console.log('URL changed to: ', window.location.href);

if (window.location.href.includes("?filter")) {
    // console.log("URL contains '?filter'");
 //  removeStyles();
 setTimeout(() => {
   // console.log('url has filter');
    carouselifyCollectionNew();
   
}, 2000);
}else{
   setTimeout(() => {
  // carouselifyCollectionNew();
}, 3000);
}

}

// Event listener for history changes (back, forward, etc.)
window.addEventListener('popstate', onUrlChange);

// Event listener for hash changes (URL fragments)
window.addEventListener('hashchange', onUrlChange);

// Overriding pushState and replaceState to catch URL changes via history API
(function(history) {
var pushState = history.pushState;
var replaceState = history.replaceState;

history.pushState = function(state, title, url) {
    var result = pushState.apply(history, arguments);
    onUrlChange();
    return result;
};

history.replaceState = function(state, title, url) {
    var result = replaceState.apply(history, arguments);
    onUrlChange();
    return result;
};
})(window.history);
